/** Default landing route when dashboard is disabled. */
export const DEFAULT_APP_PATH = "/users";
